import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';

interface Props {
    value: boolean,
    text: string,
    icon?: ReactNode,
    className?: string
}
export default observer(function AccessoryItem({ value, text, icon, className }: Props) {
    return (
        <div
            className={cn(
                'rounded-[100px] h-[30px] min-w-24 px-5 py-1 flex justify-center items-center gap-1.5',
                value ? 'bg-primaryWeb' : 'bg-border-gray',
                className
            )}
        >
            {icon && icon}
            <div className='text-fs-mid14 font-bold text-customWhite whitespace-nowrap'>
                {text}
            </div>
        </div>
    );
});
